__turbopack_context__.v({
  "arrow": "testimonial-module-scss-module__HQuMfG__arrow",
  "author": "testimonial-module-scss-module__HQuMfG__author",
  "company": "testimonial-module-scss-module__HQuMfG__company",
  "grid": "testimonial-module-scss-module__HQuMfG__grid",
  "hasPage": "testimonial-module-scss-module__HQuMfG__hasPage",
  "logo": "testimonial-module-scss-module__HQuMfG__logo",
  "name": "testimonial-module-scss-module__HQuMfG__name",
  "quote": "testimonial-module-scss-module__HQuMfG__quote",
  "testimonial": "testimonial-module-scss-module__HQuMfG__testimonial",
  "title": "testimonial-module-scss-module__HQuMfG__title",
});
